export const itemsEditorStyles = {
  section: {},
  itemContainer: {
    marginBottom: "24px",
  },
  itemHeader: {
    marginBottom: "16px",
  },
  itemTitle: {
    root: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#323130",
    },
  },
  removeButton: {
    root: {
      minWidth: "auto",
      padding: "4px 12px",
      fontSize: "12px",
      backgroundColor: "transparent",
      color: "#d13438",
      border: "1px solid #d13438",
      "&:hover": {
        backgroundColor: "#fde7e9",
      },
    },
  },
  row: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
  fieldGroup: {
    flex: 1,
    minWidth: "120px",
    maxWidth: "180px",
  },
  fieldGroupWide: {
    flex: 2,
    minWidth: "200px",
    maxWidth: "300px",
  },
  fieldGroupWideAlone: {
    flex: 1,
    minWidth: "200px",
    maxWidth: "400px",
  },
  dimensionsGroup: {
    flex: 1,
    minWidth: "280px",
  },
  dimensionsLabel: {
    root: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#605e5c",
      marginBottom: "4px",
    },
  },
  dimensionsRow: {
    gap: "8px",
    alignItems: "center",
  },
  dimensionField: {
    width: "70px",
  },
  dimensionSeparator: {
    root: {
      fontSize: "16px",
      color: "#605e5c",
      margin: "0 4px",
      alignSelf: "flex-end",
      paddingBottom: "8px",
    },
  },
  hazardousGroup: {
    flex: 1,
    display: "flex",
    alignItems: "flex-end",
    minWidth: "180px",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  checkboxLabel: {
    root: {
      fontSize: "13px",
      color: "#323130",
    },
  },
  itemDivider: {
    height: "1px",
    backgroundColor: "#edebe9",
    margin: "24px 0",
  },
  addButton: {
    root: {
      backgroundColor: "transparent",
      color: "#0078d4",
      border: "1px solid #0078d4",
      borderRadius: "4px",
      padding: "8px 16px",
      fontSize: "13px",
      marginTop: "8px",
      "&:hover": {
        backgroundColor: "#f3f9fd",
      },
    },
  },
};
